"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Core = require("../Core");
var _cssVarsPonyfill = _interopRequireDefault(require("css-vars-ponyfill"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _variables = _interopRequireDefault(require("./variables.js"));
var _ThemeCss = _interopRequireDefault(require("./Theme.css.js"));
var _Theme = _interopRequireDefault(require("./Theme.utils"));
var _ToastContext = require("../Toast/ToastContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Theme Component
 *
 * Append the theme variables css manually via AppendCss so that we can set
 * it to :root, which gets picked by all html nodes.. vs if we just use
 * ThemeDiv around props.children, modals and flyouts lose touch with the
 * vars beacuse they aren't decendents of the themeDiv tag.
 *
 * @export
 * @class Theme
 * @extends {Component}
 */
class Theme extends _react.Component {
  constructor(props) {
    super(props);
    (0, _Core.AppendAssets)();
    this.cssVarObj = {};
    this.setThemeVarsCss = this.setThemeVarsCss.bind(this);
    this.updateCssVars = this.updateCssVars.bind(this);
  }
  setThemeVarsCss(css) {
    let self = this;
    let cssString = ":root {";
    let applyProp = function (k, v) {
      cssString += k + ":" + v + ";";
      self.cssVarObj[k] = v;
    };
    const keyColors = ["primary", "accent", "error", "success"];
    for (let x in css) {
      let value = css[x];
      let key = "--" + x;
      applyProp(key, value);
      if (keyColors.includes(x)) {
        // set dark/hover and light/disabled values for primary color

        let keyDark = key + "_dark";
        let keyDarkValue = _Theme.default.shadeColor(value, -0.2);
        let keyLight = key + "_light";
        let keyLightValue = _Theme.default.shadeColor(value, 0.6);
        applyProp(keyDark, keyDarkValue);
        applyProp(keyLight, keyLightValue);
      } else if (x === "black") {
        // set black shades based on black value

        let arr = ["90", "80", "70", "60", "50", "40", "30", "20", "15", "10", "07"];
        // rgba colors
        for (let p = 0; p < arr.length; p++) {
          let percent = arr[p];
          let pKey = key + "_" + percent;
          let pValue = _Theme.default.shadeBlackColors(value, percent);
          applyProp(pKey, pValue);
        }
        // rgb colors
        for (let q = 0; q < arr.length; q++) {
          let percent = arr[q];
          let pKey = key + "_" + percent + "_S";
          let pValue = _Theme.default.shadeColor(value, "0." + (100 - parseInt(percent)));
          applyProp(pKey, pValue);
        }
      }
    }
    applyProp("--light_blue_10", "rgba(0, 207, 249, .1)"); // solid #E5FAFE
    applyProp("--light_blue_25", "rgba(0, 207, 249, .25)");
    cssString += "}";
    (0, _appendCss.default)("adc_theme_vars", cssString, true);

    // if legacy browser.. need to do some extra work...
    let allowsCssVars = window.CSS && window.CSS.supports && window.CSS.supports("(--foo: red)");
    if (!allowsCssVars) {
      // initial update of existing css vars.
      this.updateCssVars();

      // Select the node that will be observed for mutations
      let targetNode = document.getElementsByTagName("head")[0];

      // Options for the observer (which mutations to observe)
      let config = {
        childList: true
      };

      // Callback function to execute when mutations are observed
      let callback = function (mutationsList) {
        let count = 0;
        if (mutationsList.length > 0) {
          for (let i = 0; i < mutationsList.length; i++) {
            //for (let mutation of mutationsList) { /** doesn't work in the target browser (IE11) for some reason */
            if (mutationsList[i].type === "childList") {
              // just increment the count.. no need to run this multiple times per update.
              count++;
            }
          }
          if (count > 0) {
            // now update if child list changed.
            self.updateCssVars();
          }
        }
      };

      // Create an observer instance linked to the callback function
      let observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    }
  }
  updateCssVars() {
    (0, _cssVarsPonyfill.default)({
      include: "link[rel=stylesheet],style",
      variables: this.cssVarObj
    });
  }
  render() {
    const mergedTheme = {
      ..._variables.default,
      ...this.props.customTheme
    };
    const comp = /*#__PURE__*/_react.default.createElement(_ThemeCss.default, {
      customTheme: mergedTheme
    });
    this.setThemeVarsCss(comp.props.customTheme);
    return /*#__PURE__*/_react.default.createElement(_ToastContext.ToastProvider, null, this.props.children);
  }
}
Theme.propTypes = {
  /** A JSON object of color values to override and/or apply to the default CSS variables */
  customTheme: _propTypes.default.object
};
Theme.defaultProps = {
  customTheme: {}
};
var _default = exports.default = Theme;